import { createFileRoute } from "@tanstack/react-router";

import { useUser } from "@/features/auth/hooks/use-user";
import { ClientDashboard } from "@/features/dashboard/modules/client-dashboard/client-dashboard";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/dashboard/")({
  loader: () => ({ crumb: m.layout_nav_dashboard() }),
  component: DashboardPage,
});

/**
 * Sign-in lands everyone here, and it is the client's home for everyone: no permission is
 * asked for and nobody is sent on. The team's own start page is `/today`.
 */
function DashboardPage() {
  const { user } = useUser();
  return <ClientDashboard firstName={user.firstName ?? ""} />;
}
